const footerNav = [
  {
    title: '内容栏目',
    links: [
      { href: '#daily', label: '今日精选' },
      { href: '#hot', label: '人气榜单' },
      { href: '#booklist', label: '追更书单' },
      { href: '#category', label: '主题分类' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { href: '#about', label: '编辑团队' },
      { href: '#faq', label: '常见问题' },
      { href: '#contact', label: '联系我们' },
    ],
  },
];

const socials = [
  { icon: 'ri-wechat-fill', label: '微信公众号' },
  { icon: 'ri-weibo-fill', label: '微博' },
  { icon: 'ri-bilibili-fill', label: '哔哩哔哩' },
  { icon: 'ri-douban-fill', label: '豆瓣' },
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-800 bg-background-900">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col gap-4 lg:col-span-2">
            <a href="#hero" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-foreground-950">
                <i className="ri-leaf-fill" />
              </span>
              <span className="font-heading text-xl font-bold text-primary-300">香蕉漫画社</span>
            </a>
            <p className="max-w-sm text-sm leading-relaxed text-foreground-400">
              香蕉漫画社编辑推荐专区，聚合站内人气作品与口碑漫画。每日更新精选书单与追更入口，
              帮你快速找到值得追的好漫画。
            </p>
            <div className="flex items-center gap-2">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href="#contact"
                  aria-label={s.label}
                  title={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-700 text-lg text-foreground-400 transition-colors hover:border-primary-500/50 hover:text-primary-300"
                >
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          {footerNav.map((group) => (
            <nav key={group.title} aria-label={group.title}>
              <h4 className="mb-4 text-sm font-bold text-foreground-100">{group.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="inline-flex items-center gap-2 text-sm text-foreground-400 transition-colors hover:text-primary-300"
                    >
                      <i className="ri-arrow-right-s-line text-xs text-foreground-600" />
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 香蕉漫画社 · 每天为你精选值得追的好漫画</p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <a href="#faq" className="transition-colors hover:text-primary-300">帮助中心</a>
            <a href="#contact" className="transition-colors hover:text-primary-300">读者投稿</a>
            <span className="inline-flex items-center gap-1">
              <i className="ri-heart-3-fill text-primary-400" />
              读漫愉快
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}